import { useTheme, useMediaQuery } from '@mui/material';

// SPEC-099 (RN-001, RN-002, RN-004) — escalado de íconos lucide-react por breakpoint.
// lucide-react no acepta clamp() en su prop size (solo number), por eso no usa fs().
export const useIconScale = (basePx: number): number => {
  const theme = useTheme();
  const isWide = useMediaQuery(theme.breakpoints.up('lg')); // >=1200px MUI
  const factor = isWide ? 1.38 : 1.2;
  return Math.round(basePx * factor * 10) / 10;
};
